module.exports = __webpack_public_path__ + "static/section2-d81b3ebdbe9415ac50568d24dec18dfd.jpg";